/**
 * <zzz-sticky-promo> shows/hides the site-wide sticky mini bar: visible once
 * the page's first section has scrolled out of view, hidden again once the
 * footer comes into view (so it never covers it) or after being dismissed.
 */
class ZzzStickyPromo extends HTMLElement {
  pastFirstSection = false;
  nearFooter = false;

  connectedCallback() {
    if (sessionStorage.getItem('zzz-sticky-dismissed') === '1') {
      this.remove();
      return;
    }

    this.querySelector('[data-zzz-sticky-dismiss]')?.addEventListener('click', () => this.dismiss());

    const main = document.querySelector('#MainContent');
    const firstSection = main?.querySelector(':scope > .shopify-section');
    const footer = document.querySelector('footer');

    if (firstSection && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.pastFirstSection = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.updateVisibility();
          });
        },
        { threshold: 0 }
      ).observe(firstSection);
    } else {
      this.pastFirstSection = true;
    }

    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.nearFooter = entry.isIntersecting;
            this.updateVisibility();
          });
        },
        { threshold: 0 }
      ).observe(footer);
    }

    this.updateVisibility();
  }

  updateVisibility() {
    this.hidden = !(this.pastFirstSection && !this.nearFooter);
  }

  dismiss() {
    sessionStorage.setItem('zzz-sticky-dismissed', '1');
    this.hidden = true;
  }
}

if (!customElements.get('zzz-sticky-promo')) {
  customElements.define('zzz-sticky-promo', ZzzStickyPromo);
}
